import { render, staticRenderFns } from "./VuePicZoom.vue?vue&type=template&id=16ef2f78&scoped=true"
import script from "./VuePicZoom.vue?vue&type=script&lang=js"
export * from "./VuePicZoom.vue?vue&type=script&lang=js"
import style0 from "./VuePicZoom.vue?vue&type=style&index=0&id=16ef2f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef2f78",
  null
  
)

export default component.exports